import {MdPanoramaHorizontal, MdVrpano} from 'react-icons/md';
import React from 'react';
import InAppTooltip from './UnityReactComponents/InAppTooltip';
import {useSelector} from 'react-redux';

const PanoIcon = ({
  streetViewId,
}) => {
  const inAppPanoId = useSelector(state => state.inApp.panoId);
  const isCurrentPano = streetViewId === inAppPanoId;

  return (
    <InAppTooltip
      message={isCurrentPano
        ? `Place's 360 is currently loaded`
        : streetViewId
          ? `Place has a 360`
          : `No 360 attached to this place`}
    >
      {streetViewId
        ? (
          <MdVrpano
            color={isCurrentPano
              ? '#33bbff'
              : '#BFBFBF'}
            size="1.5em"
          />)
        : (
          <MdPanoramaHorizontal
            color="#BFBFBF"
            size="1.5em"
          />)}
    </InAppTooltip>
  );
};


export default PanoIcon;